define('modules/start/products/headers/active/view',['require','exports','module','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        serialize: function() {
            return {
                isAdm: this.isAdm               
            };
        }
    });

    module.exports = Layout;
});
